import { Outlet } from 'react-router'
import { LeftRail } from './LeftRail'
import { TopBar } from './TopBar'

/** Desktop-first frame: top bar, section rail, content. Holds down to tablet width. */
export function AppShell() {
  return (
    <div className="flex h-full min-h-0 flex-col bg-bg">
      <TopBar />
      <div className="flex min-h-0 flex-1">
        <LeftRail />
        <main className="relative min-w-0 flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
